import Home from "./pages/HomePage";
function App() {
  return (
    <Home />
  );
}

export default App;
